var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Grid",
    "data-name": "Circle Grid"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#f6c863",
    r: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.683 27.953h52.444v75.781h-52.444z",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.375 23-2.485 4.953h48.029l-2.485-4.953z",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.389 33.04h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.057 33.04-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.698 33.04v.863l-10.101 10.101h-1.208v-1.019l9.945-9.945z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58.251 33.04h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.919 33.04-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.561 33.04v.863l-10.101 10.101h-1.209v-1.019l9.946-9.945z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.114 33.04h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.782 33.04-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.423 33.04v.863l-10.1 10.101h-1.209v-1.019l9.945-9.945z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.389 48.94h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.057 48.94-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.698 48.94v.863l-10.101 10.101h-1.208v-1.018l9.945-9.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58.251 48.94h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.919 48.94-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.561 48.94v.863l-10.101 10.101h-1.209v-1.018l9.946-9.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.114 48.94h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.782 48.94-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.423 48.94v.863l-10.1 10.101h-1.209v-1.018l9.945-9.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.389 65.844h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.057 65.844-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.698 65.844v.863l-10.101 10.101h-1.208v-1.018l9.945-9.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58.251 65.844h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.919 65.844-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.561 65.844v.863l-10.101 10.101h-1.209v-1.018l9.946-9.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.114 65.844h11.31v10.964h-11.31z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.782 65.844-8.668 8.685v-1.174l7.511-7.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.423 65.844v.863l-10.1 10.101h-1.209v-1.018l9.945-9.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m49.834 84.404h28.141v18.498h-28.141z",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.729 100.804h60.543v4.196h-60.543z",
    fill: "#62667c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.097 83.914h3.614v16.89h-3.614z",
    fill: "#eeefee"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.0fe02d43.svg";
export { ForwardRef as ReactComponent };